<div dbMainHeaderContent class="db-main-header-content">
  <div class="header-title">
    <div class="texts">
      <span class="db-center"><img src="assets/images/logos/10web_name_logo_dark.svg" /></span>
    </div>
  </div>
</div>

<div class="db-migration-steps">
  <div dbCustomScrollbar>
    <div class="db-migration-steps-main-wrap">
      <h1 class="db-migration-steps__title" [ngClass]="{'db-with-slack-agency': agencyOrFreelancer}">Just a Few Steps Left to Migrate Your Website.</h1>
      <h2 class="db-migration-steps__sub-title">It’s secure and won’t <br/>affect your live website</h2>
      <p class="db-migration-steps__link">Here you can <a (click)="downloadManagerPlugin()">download 10Web Manager</a> again.</p>
      <div class="db-migration-steps__card-grid">
        <div class="db-migration-steps__card" *ngFor="let step of steps, let i = index">
          <div class="db-migration-steps__card-body">
            <p class="db-card-step" [innerHTML]="'STEP ' + (i + 1)"></p>
            <h3 class="db-card-title" [innerHTML]="step.title"></h3>
            <p class="db-card-desc" [innerHTML]="step.desc"></p>
          </div>
          <div class="db-migration-steps__card-image">
            <img [src]="step.image" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


